import React from 'react';
import HeaderThree from '../../common/header/HeaderThree';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import WelcomeThree from '../../components/section-components/WelcomeThree';
import AwardOne from '../../components/section-components/AwardOne';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasThree from '../../components/section-components/PracticeAreasThree';
import OurAttorneysThree from '../../components/section-components/OurAttorneysThree';
import Counter from '../../components/section-components/Counter';
import FooterThree from '../../common/footer/FooterThree';

const AboutUsTwo = () => {
    return (
        <>
        <HeaderThree />

        <BreadcrumbOne 
            title="About Us 2"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="About Us 2"
        />
        
        <WelcomeThree />
        
        <AwardOne /> 
        
        <Experiences />
        
        <PracticeAreasThree />
        
        <OurAttorneysThree />
        
        <Counter />

        <FooterThree />
        </>
    )
}
    
export default AboutUsTwo;